import React from 'react';
import { Button } from '@mui/material';

const BANNER_ACTION_SX = {
  bgcolor: 'warning.dark',
  color: 'warning.contrastText',
  '&:hover': {
    bgcolor: 'warning.light',
  },
};

/**
 * Contained action on warning-colored surfaces (e.g. impersonation banner).
 */
const WarningBannerActionButton = React.forwardRef(function WarningBannerActionButton(
  { variant = 'contained', color = 'inherit', size = 'small', sx, ...props },
  ref
) {
  return (
    <Button
      ref={ref}
      variant={variant}
      color={color}
      size={size}
      sx={[BANNER_ACTION_SX, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      {...props}
    />
  );
});

export default WarningBannerActionButton;
